import { ca } from '@cian/analytics';

import { IVillageForListPresenterSchema } from '../../repositories/countryside-search/entities/village/VillageForListPresenterSchema';

export function trackCardOpened(village: IVillageForListPresenterSchema) {
  ca('event', {
    action: 'goto_CardKP',
    category: 'Listing_KP',
    label: '',
    name: 'oldevent',
    oid: village.id,
  });
}

export function trackListingObjectsOpened(village: IVillageForListPresenterSchema, resale?: boolean) {
  ca('event', {
    action: resale ? 'goto_listing_from_agents' : 'goto_listing_from_developer',
    category: 'Listing_KP',
    label: '',
    name: 'oldevent',
    oid: village.id,
  });
}

export const trackHighwayClicked = () =>
  ca('event', {
    action: 'goto_listingKP',
    category: 'Listing_KP',
    label: 'highway_click',
    name: 'oldevent',
  });

export const trackRailwayClicked = () =>
  ca('event', {
    action: 'goto_listingKP',
    category: 'Listing_KP',
    label: 'railway_click',
    name: 'oldevent',
  });
